import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
/**
 * Api is a generic REST Api handler. Set your API url first.
 */

declare const webpackGlobalVars: any;

@Injectable()
export class Api {
  url: string = webpackGlobalVars.apiUrl;
  API_KEY: string = webpackGlobalVars.apiKey;

  constructor(public http: HttpClient) { }

  get(endpoint: string, params?: any, reqOpts?: any) {
    if (!reqOpts) {
      reqOpts = {
        params: new HttpParams()
      };
    }

    // Support easy query params for GET requests
    if (params) {
      reqOpts.params = new HttpParams();
      for (let k in params) {
        reqOpts.params = reqOpts.params.set(k, params[k]);
      }
    }
    reqOpts.headers = new HttpHeaders({
      'X-API-KEY': this.API_KEY
    });
    return this.http.get(this.url + '/' + endpoint, reqOpts);
  }

  post(endpoint: string, body: any, reqOpts?: any) {
    if (!reqOpts) {
      reqOpts = {};
    }
    reqOpts.headers = new HttpHeaders({
      'X-API-KEY': this.API_KEY
    });
    return this.http.post(this.url + '/' + endpoint, body, reqOpts);
  }

  put(endpoint: string, body: any, reqOpts?: any) {
    if (!reqOpts) {
      reqOpts = {};
    }
    reqOpts.headers = new HttpHeaders({
      'X-API-KEY': this.API_KEY
    });
    return this.http.put(this.url + '/' + endpoint, body, reqOpts);
  }

  delete(endpoint: string, reqOpts?: any) {
    if (!reqOpts) {
      reqOpts = {};
    }
    reqOpts.headers = new HttpHeaders({
      'X-API-KEY': this.API_KEY
    });
    return this.http.delete(this.url + '/' + endpoint, reqOpts);
  }

  patch(endpoint: string, body: any, reqOpts?: any) {
    if (!reqOpts) {
      reqOpts = {};
    }
    reqOpts.headers = new HttpHeaders({
      'X-API-KEY': this.API_KEY
    });
    return this.http.put(this.url + '/' + endpoint, body, reqOpts);
  }
}



// WEBPACK FOOTER //
// ./src/providers/api/api.ts